/** @format */

import {useState} from 'react';

import Tippy from '@tippyjs/react';

import {IconButton} from '@sttark/design-system';

export function Popover({placement, title, content, children, ...props}) {
    const [tippy, setTippy] = useState(null);
    const [visible, setVisible] = useState(false);
    return (
        <Tippy
            interactive
            placement={placement}
            onCreate={tippy => setTippy(tippy)}
            onShow={() => setVisible(true)}
            onHide={() => setVisible(false)}
            appendTo={() => document.body}
            render={attrs => {
                return (
                    visible && (
                        <PopoverBox
                            {...attrs}
                            placement={attrs['data-placement']}
                            title={title}
                            onClose={() => tippy.hide()}
                            maxWidth={props.maxWidth}>
                            {content}
                        </PopoverBox>
                    )
                );
            }}
            {...props}>
            {children}
        </Tippy>
    );
}

Popover.defaultProps = {
    placement: 'top',
    maxWidth: 300,
    trigger: 'click'
};

export function PopoverBox({title, children, placement, onClose, maxWidth}) {
    return (
        <div
            className={`popover-sttark-ds popover popover--placement-${placement} content-box bg-structure-lightest p-4`}
            style={{maxWidth: maxWidth}}>
            <IconButton
                secondary
                className="position-absolute top-0 end-0 p-2"
                size="small"
                icon={'CloseIcon'}
                onClick={onClose}
            />
            <div className="popover__arrow" data-popper-arrow=""></div>
            {title && (
                <p>
                    <strong>{title}</strong>
                </p>
            )}
            {children}
        </div>
    );
}
